// extracted by css-extract-rspack-plugin
export default {"root":"RowIdCell-module__root___mZAO5","rowNumber":"RowIdCell-module__rowNumber___coHX_","expandButton":"RowIdCell-module__expandButton___KEdQV"};